import * as t from "./actions";
import { Report, ReportFile } from "./constants";

export interface ReportModuleState {
  reports: Report[];
  files: ReportFile[];
}

let initialState: ReportModuleState = {
  reports: [],
  files: []
};

export default function (
  state = initialState,
  action: IPayload
): ReportModuleState {
  switch (action.type) {
    case t.ADD_REPORTS:
      return {
        ...state,
        reports: action.payload
      };

    case t.GET_REPORTS_FAILURE:
      // TODO handle errors
      console.error("getReports failed!");
      return state;

    case t.ADD_REPORT_FILES:
      return {
        ...state,
        files: action.payload
      };

    case t.GET_REPORT_FILES_FAILURE:
      // TODO handle errors
      console.error("getReportFiles failed!");
      return state;

    case t.FLUSH_REPORTS:
      return {
        ...state,
        reports: []
      };

    case t.FLUSH_REPORT_FILES:
      return {
        ...state,
        files: []
      };

    case t.DELETE_REPORT:
      return state;

    case t.DELETE_REPORT_FAILURE:
      return state;

    case t.RESEND_REPORT_FILE:
      return state;

    case t.RESEND_REPORT_FILE_FAILURE:
      return state;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./client/modules/Report/reducer.ts